import React, { useEffect, useState } from "react";
import ScopeOfTheLaboratory_Form from "./scopeOfTheLaboratory_Form/ScopeOfTheLaboratory_Form";
import Common_Back_Btn from "../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import ScopeOfTheLaboratory_table from "./scopeOfTheLaboratory_table/ScopeOfTheLaboratory_table";
import {
  Create,
  GetAll,
} from "../../../../../../../src/features/admin/quality_management/structural_requirement/scope_of_laboratoy/Slice";
import { useDispatch, useSelector } from "react-redux";
import { FixIDS } from "../../../../../../utils/fixIDS";

function ScopeOfTheLaboratory() {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const scope_of_laboratory = useSelector((state) => state.scope_of_laboratory);
  // console.log("scope_of_laboratory ", scope_of_laboratory);

  const fetchCustomers = async (page = 1) => {
    await dispatch(
      GetAll({
        page,
        per_page: scope_of_laboratory.per_page,
      }),
    );
  };

  useEffect(() => {
    fetchCustomers(currentPage);
  }, [currentPage]);

  const permissions = useSelector((state) => state.auth.permissions);

  const haveReadPermission = permissions?.includes(
    FixIDS.scope_of_laboratory.List,
  );
  const haveAddPermission = permissions?.includes(
    FixIDS.scope_of_laboratory.Add,
  ); //form

  return (
    <>
      <section className="Imperiality Quality_Policy ScopeOfTheLaboratory">
        <div className="back_div">
          <Common_Back_Btn backText="Scope of the Laboratory" />
        </div>
        <div className="white_container customer_section">
          {/* Note text */}
          <div className="note_text_holder">
            <p>
              Our company is committed to maintaining the highest standards of
              accuracy, reliability, and integrity in all laboratory operations.
              We ensure continuous improvement of our processes, compliance with
              quality standards, and customer satisfaction through effective
              documentation and controlled file management — including secure
              addition and deletion of files as per QMS guidelines.
            </p>
          </div>
        </div>

        <div className="imperiality_Form_div">
          {haveAddPermission && <ScopeOfTheLaboratory_Form />}
        </div>

        <div className="imperiality_table_div">
          {haveReadPermission && (
            <ScopeOfTheLaboratory_table
              data={scope_of_laboratory}
              setCurrentPage={setCurrentPage}
              currentPage={currentPage}
              fetchCustomers={fetchCustomers}
            />
          )}
        </div>
      </section>
    </>
  );
}

export default ScopeOfTheLaboratory;
